import { render, staticRenderFns } from "./EditPersonModal.vue?vue&type=template&id=0b2a320a&scoped=true&"
import script from "./EditPersonModal.vue?vue&type=script&lang=js&"
export * from "./EditPersonModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonModal.vue?vue&type=style&index=0&id=0b2a320a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2a320a",
  null
  
)

export default component.exports